import {
  Box,
  Drawer,
  Heading,
  Loader,
  Stack,
  useResponsiveValue,
} from 'braid-design-system';
import React, { useId, type ReactElement } from 'react';

const breakpoints = {
  mobile: 0,
  tablet: 1,
  desktop: 2,
  wide: 3,
} as const;

export const ResponsiveDrawerOrInline = ({
  onClose,
  title,
  children,
  inlineAt,
}: {
  onClose: () => void;
  title: string;
  children: ReactElement;
  inlineAt: keyof typeof breakpoints;
}) => {
  const id = useId();
  const breakpointValue = useResponsiveValue()(breakpoints);

  if (breakpointValue === null) {
    return <Loader />;
  }

  const child = React.cloneElement(children, { key: 'preserved' });

  if (breakpointValue < breakpoints[inlineAt]) {
    return (
      <Drawer onClose={onClose} open title={title} id={id}>
        {child}
      </Drawer>
    );
  }

  return (
    <Box paddingY="small">
      <Stack space="medium">
        <Heading level="3">{title}</Heading>
        {child}
      </Stack>
    </Box>
  );
};
